import React from 'react';
import { ToastOptions, toast } from 'react-toastify';
import { ErrorCircle, IconMessageWrap } from './ToastsStyled';
import { Icon, IconAlert, IconAlertSuccess } from '../../../styles/Icons';
import { colors } from '../../../styles/GlobalStyles';
import { P3 } from '../../../styles/FontStyles';

const toastConfig: ToastOptions = {
  icon: false,
  hideProgressBar: true,
  pauseOnHover: true,
  autoClose: 5000,
  position: 'top-center',
  draggable: true,
  closeOnClick: true
};

export const SuccessToast = (
  successMessage?: string,
  successMessage2?: string
) => {
  toast.success(
    <SuccessToastComponent
      successMessage={successMessage ?? 'Success'}
      successMessage2={successMessage2 ?? ''}
    />,
    toastConfig
  );
};

export const ErrorToast = (errorMessage?: string) => {
  toast.error(
    <ErrorToastComponent errorMessage={errorMessage ?? 'Error'} />,
    toastConfig
  );
};

export const SuccessToastComponent = ({
  successMessage,
  successMessage2
}: {
  successMessage: string;
  successMessage2?: string;
}) => (
  <>
    <IconMessageWrap>
      <ErrorCircle success>
        <Icon color={colors.neutral50}>
          <IconAlertSuccess />
        </Icon>
      </ErrorCircle>
      <P3 color={colors.neutral900}>
        {successMessage} <br /> {successMessage2 ? successMessage2 : ''}
      </P3>
    </IconMessageWrap>
  </>
);

export const ErrorToastComponent = ({
  errorMessage
}: {
  errorMessage: string;
}) => (
  <>
    <IconMessageWrap>
      <ErrorCircle>
        <Icon color={colors.neutral50}>
          <IconAlert />
        </Icon>
      </ErrorCircle>

      <P3 color={colors.neutral900}>{errorMessage}</P3>
    </IconMessageWrap>
  </>
);
